import React, { PropTypes } from 'react';
import SearchBarContainer from '../../containers/SearchBarContainer';
import DocumentItem from './DocumentItem';
import FooterButtons from './FooterButtons';
import Pagination from '../Common/Pagination';
import { isEqual } from 'lodash';
import RemoveAccents from 'remove-accents';

export default class DocumentsList extends React.Component {
	
	componentWillMount() {
		this.props.actions.clearForm();
		this.props.actions.getDocuments();		
	}

	componentDidUpdate(prevProps) {
		if ( !isEqual(prevProps.documents.filter, this.props.documents.filter) ) {
			this.props.actions.setCurrentPage(1);
		}
		// reseta ao mudar de pagina
		if ( !isEqual(prevProps.projects, this.props.projects) ) {
			this.props.actions.setCurrentPage(1);
		}
	}

	getGroupName(groups, hasOwner) {
		if ( !hasOwner ) return "Público";
		const filtered = this.props.groups.list.find((g) => g.id === groups[0]);
		return typeof filtered === "undefined" ? "" : filtered.name;
	}

	getGroupId(groups, hasOwner) {
		if ( !hasOwner ) return 0;
		const filtered = this.props.groups.list.find((g) => g.id === groups[0]);
		return typeof filtered === "undefined" ? null : filtered.id;
	}

	filterByPage(array, itemsPerPage, page) {
		const endIndex = itemsPerPage * page - 1;
		const startIndex = endIndex - itemsPerPage + 1;
		return array.slice(startIndex, endIndex + 1);
	}

	getTotalPages() {
		const { itemsPerPage } = this.props.documents.pagination;
		return Math.ceil(this.filterByState().length / itemsPerPage);
	}

	getTotalDocuments() {
		return this.filterByState().length;
	}

	getDocuments() {
		const { itemsPerPage, currentPage } = this.props.documents.pagination;
		return this.filterByPage(this.filterByState(), itemsPerPage, currentPage);
	}

	filterByProject(list) {
		var isMariana = this.props.projects.isMariana;
		var isBrumadinho = this.props.projects.isBrumadinho;
		if ( isMariana && !isBrumadinho ) {
			return this.props.projects === null ? list
					: list.filter((d) => d.projects[0] === 1);
		} else if ( !isMariana && isBrumadinho ) {
			return this.props.projects === null ? list
					: list.filter((d) => d.projects[0] === 2);
		} else if ( isMariana && isBrumadinho ) { 
			//user nos dois
			return list;
		} else {
			// retorna lista vazia, uma vez que -1 nao eh uma
			// id de projeto valida
			return this.props.projects === null ? list
					: list.filter((d) => d.projects[0] === -1);
			
		}
		
	}

	filterByFolder(list) {
		return this.props.documents.filter.folder === null 
			? list
			: list.filter((d) => d.folder === this.props.documents.filter.folder.value);
	}

	filterByGroups(list) {
		if ( this.props.documents.filter.selectedGroups.length === 0 ) return list;

		// If any group was selected, filter by groups first
		const groupIds = [];
		this.props.documents.filter.selectedGroups.map((g) => groupIds.push(g.value));

		return list.filter((d) => groupIds.indexOf(d.groups[0]) > -1 && d.hasOwner);
	}

	filterByVisibility(list) {
		return list.filter((d) => d.isFavorite || this.props.documents.filter.visibility === "all");
	}

	filterByKeywords(list) {
		if ( this.props.documents.filter.selectedKeywords.length === 0 ) return list;

		const ids = [];
		this.props.documents.filter.selectedKeywords.map((k) => ids.push(k.value));
		
		return list.filter((d) => {
			let result = false;
			ids.map((id) => { if ( d.keywords.indexOf(id) > -1 ) result = true; });
			return result;
		});
	}

	filterByShapes(list) {
		const { documents } = this.props;
		if ( documents.filter.selectedSectors.length === 0 && documents.filter.selectedLocalities.length === 0 ) {
			return list;
		}

		const ids = [];
		this.props.documents.filter.selectedSectors.map((s) => ids.push(s.value));
		this.props.documents.filter.selectedLocalities.map((s) => ids.push(s.value));

		return list.filter((d) => {
			let result = false;
			ids.map((id) => { if ( d.shapes.indexOf(id) > -1 ) result = true; });
			return result;
		});
	}

	termCheckerWordWrapper(term, text) {
		const regex = `(\\s(${term})\\s)`;
		return new RegExp(regex).test(text);
	}

	compareNumberToTerms(number, terms) {
		var outputID = false;
		terms.forEach((term) => {
			if (outputID === true) return;
			if (number.toString() === term) {
				outputID = true;
				return true;
			} else { return false; }
		});
		return outputID;
	}

	filterBySearchTerms(list) {
		const terms = this.props.documents.filter.selectedTerms;
		const wholeWordOnly = this.props.documents.filter.wholeWord;
		if ( terms.length === 0 ) return list;

		return list.filter((doc) => {
			const title = RemoveAccents.remove(doc.title.toLowerCase().normalize());
			if (wholeWordOnly) {
				var outputId = true;
				var outputTitle = true;
				outputId = this.compareNumberToTerms(doc.id, terms);
				terms.forEach((term) => {
					if (this.termCheckerWordWrapper(term, title) === false) outputTitle = false;
				});
				return outputId || outputTitle;

			} else {
				
				if (this.compareNumberToTerms(doc.id, terms)) {
					return true;
				}
				if (new RegExp(terms.join("|")).test(title)) {
					return true;
				}
			}

			// A descricao nao esta disponivel no contexto da lista de documentos
			// if (new RegExp(terms.join("|")).test(doc.description)) {
			// 	return true;
			// }

			return false;
		});
	}

	filterByState() {
		const { list } = this.props.documents;
		return this.filterByProject(
				this.filterBySearchTerms(
					this.filterByVisibility(
						this.filterByGroups(
							this.filterByFolder(
								this.filterByKeywords(
									this.filterByShapes(list)
								)
							)
						)
					)
				)
			);
	}

	render () {
		const { actions, documents, getGeom } = this.props;
		// Shows loader if fetching documents and list is empty

		if ( documents.isFetching && documents.list.length === 0 ) {
			return (
				<div style={{display: "flex"}}>
					<span style={{margin: "auto"}}>
						Carregando Documentos
						&nbsp;
						<i className="fas fa-circle-notch fa-spin fa-fw" />
					</span>
				</div>
			);
		}
		return (
			<div>				
				<SearchBarContainer 
					projects={this.props.projects}
				/>
				<div>
					{this.getDocuments().map((doc, i) => 
						<DocumentItem							
							isSelecting={documents.isSelecting}
							isFavorite={doc.isFavorite}							
							viewDocument={actions.viewDocument}
							getDocumentLocations={actions.getDocumentLocations}
							getDocumentDetails={actions.getDocumentDetails}
							getDocumentFiles={actions.getDocumentFiles}
							getGeom={getGeom}
							downloadFile={actions.downloadFile}
							downloadFilesAsZip={actions.downloadFilesAsZip}														
							deleteFile={actions.deleteFile}
							toggleFavorite={actions.toggleFavorite}
							groupName={this.getGroupName(doc.groups, doc.hasOwner)}
							groupId={this.getGroupId(doc.groups, doc.hasOwner)}
							index={i}
							key={i} 
							title={doc.title} 
							id={doc.id}							
						/>
					)}
				</div>
				<Pagination 
					pagination={this.props.documents.pagination} 
					setPage={actions.setCurrentPage}
					totalPages={this.getTotalPages()} 
					totalDocuments={this.getTotalDocuments()}
				/>
				<FooterButtons export={() => this.props.actions.exportList(this.filterByState())} />
			</div>
		);
	}
}

DocumentsList.propTypes = {
	actions: PropTypes.object.isRequired,
	documents: PropTypes.object.isRequired,
	groups: PropTypes.object.isRequired,
	getGeom: PropTypes.func.isRequired,
	projects: PropTypes.object.isRequired
};


// WEBPACK FOOTER //
// ./src/components/Documents/DocumentsList.js